import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Popover, PopoverOrigin } from "@mui/material";
import { useState } from "react";
import Flex from "./Flex";
import Text from "./Text";
import StatusChip from "./StatusChip";
import { CHART_TYPOGRAPHY } from "./app/provider/patient/chart";

interface MultiSpecialtyProps {
  specialties?: { [k: string]: string };
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  width?: string | number;
}

const MultiSpecialty = ({
  specialties,
  anchorOrigin,
  transformOrigin,
  width = 100,
}: MultiSpecialtyProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const allSpecialties = Object.values(specialties ?? {});

  return (
    <>
      {allSpecialties?.length === 0 && "-"}

      {allSpecialties?.length > 1 && (
        <Flex gap={1} alignItems={"center"}>
          <StatusChip variant="info" label="Multispecialty" />
          <Text
            fontSize={CHART_TYPOGRAPHY.body5.fontSize}
            onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
            onMouseLeave={() => setAnchorEl(null)}
            display={"flex"}
            alignItems={"center"}
          >
            <InfoOutlinedIcon fontSize="small" sx={{ color: "#0097F0" }} />
          </Text>
          <Popover
            id="mouse-over-popover"
            anchorEl={anchorEl}
            sx={{ pointerEvents: "none" }}
            open={open}
            anchorOrigin={
              anchorOrigin ?? {
                vertical: "top",
                horizontal: "right",
              }
            }
            transformOrigin={
              transformOrigin ?? {
                vertical: "top",
                horizontal: "left",
              }
            }
            onClose={() => setAnchorEl(null)}
            disableRestoreFocus
          >
            <Flex flexWrap={"wrap"} width={width} gap={0.5} p={0.8}>
              {allSpecialties?.map((it) => (
                <StatusChip key={it} variant="info" label={it} />
              ))}
            </Flex>
          </Popover>
        </Flex>
      )}

      {allSpecialties?.length === 1 && (
        <StatusChip
          variant="info"
          sx={{
            width: typeof width === "number" ? width / 2 : width,
          }}
          value={allSpecialties[0]}
        />
      )}
    </>
  );
};

export default MultiSpecialty;
